<template>
  <div class="box">
    <div class="pt-2 text-center">
      <slot name="header" />
    </div>
    <div class="mt-4">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "register-box",
};
</script>

<style lang="postcss">
.box {
  box-shadow: 0px 0px 10px theme("colors.primary");
  @apply w-full bg-primary rounded p-6 flex flex-col flex-wrap;
}
</style>
